/**
 * SINGLE SOURCE OF TRUTH — all game constants (ESM).
 * Tune here; import named exports where needed.
 */

/** Fixed logical board size (landscape) for layout math. */
export const GAME_BOARD_LANDSCAPE_WIDTH = 1366;
export const GAME_BOARD_LANDSCAPE_HEIGHT = 768;

/** Fall progress bar inset from play-area bottom (px). */
export const FALL_PROGRESS_BOTTOM_PX = 3;
/** @deprecated Canvas fallback only; DOM pill sits below catcher flask. */
export const FALL_HP_BOTTOM_PX = FALL_PROGRESS_BOTTOM_PX;
/** Gap between catcher flask bottom and the HP pill top (play-local px). */
export const FALL_HP_BELOW_FLASK_GAP_PX = 6;

/** Fall HP reveal: fade-in after boulder damage (ms). */
export const FALL_HP_REVEAL_FADE_IN_MS = 150;
/** Fall HP reveal: hold at full opacity (ms). */
export const FALL_HP_REVEAL_HOLD_MS = 1500;
/** Fall HP reveal: fade-out before hide (ms). */
export const FALL_HP_REVEAL_FADE_OUT_MS = 300;
/** Hearts bar total transient window in Fall (ms) — sum of reveal phases. */
export const HEARTS_TRANSIENT_HIDE_MS =
  FALL_HP_REVEAL_FADE_IN_MS + FALL_HP_REVEAL_HOLD_MS + FALL_HP_REVEAL_FADE_OUT_MS;

// ========== EVOLUTION CHAIN ==========
  // assetId → merge-tier PNG via assets/merge-tier-urls.js
  // assetCenter: [x, y] 0–1, point in image that aligns with physics position
  // imageBodyRadiusRatio: physics radius R as fraction of image's larger dimension. Smaller = more
  //   transparent padding in image, so image scales larger to fit circle within visible content.
  //   ~0.45 default; use 0.35 for lots of padding, 0.5 for tight crop.
  // ellipseAspect: width/height ratio. 1.0 = circle, 1.2 = wider, 0.8 = taller.
  // ellipseAngle: physics body rotation offset from image in radians. 0 = aligned; e.g. 0.3 tilts ellipse relative to image.
export const EVOLUTION_CHAIN = [
    { id: 0, label: "C", name: "Cell", assetId: "cell", assetCenter: [0.500, 0.500], imageBodyRadiusRatio: 0.500, ellipseAspect: 1.000, ellipseAngle: 0 },
    { id: 1, label: "S", name: "Starfish", assetId: "starfish", assetCenter: [0.500, 0.500], imageBodyRadiusRatio: 0.500, ellipseAspect: 1.000, ellipseAngle: 0 },
    { id: 2, label: "J", name: "Jellyfish", assetId: "jellyfish", assetCenter: [0.500, 0.500], imageBodyRadiusRatio: 0.500, ellipseAspect: 1.000, ellipseAngle: 0 },
    { id: 3, label: "F", name: "Fish", assetId: "fish", assetCenter: [0.500, 0.500], imageBodyRadiusRatio: 0.500, ellipseAspect: 1.000, ellipseAngle: 0 },
    { id: 4, label: "Sn", name: "Snail", assetId: "snail", assetCenter: [0.500, 0.500], imageBodyRadiusRatio: 0.500, ellipseAspect: 1.000, ellipseAngle: 0 },
    { id: 5, label: "B", name: "Bug", assetId: "bug", assetCenter: [0.500, 0.500], imageBodyRadiusRatio: 0.500, ellipseAspect: 1.000, ellipseAngle: 0 },
    { id: 6, label: "Bf", name: "Butterfly", assetId: "butterfly", assetCenter: [0.500, 0.500], imageBodyRadiusRatio: 0.500, ellipseAspect: 1.000, ellipseAngle: 0 },
    { id: 7, label: "L", name: "Lizard", assetId: "lizard", assetCenter: [0.500, 0.500], imageBodyRadiusRatio: 0.500, ellipseAspect: 1.000, ellipseAngle: 0 },
    { id: 8, label: "P", name: "Pterodactyl", assetId: "pterodactyl", assetCenter: [0.500, 0.500], imageBodyRadiusRatio: 0.500, ellipseAspect: 1.000, ellipseAngle: 0 },
    { id: 9, label: "T", name: "T-rex", assetId: "trex", assetCenter: [0.500, 0.500], imageBodyRadiusRatio: 0.500, ellipseAspect: 1.000, ellipseAngle: 0 },
    { id: 10, label: "Dr", name: "Dragon", assetId: "dragon_final", assetCenter: [0.500, 0.500], imageBodyRadiusRatio: 0.500, ellipseAspect: 1.000, ellipseAngle: 0 },
    { id: 11, label: "A", name: "Alien", assetId: "alien", assetCenter: [0.500, 0.518], imageBodyRadiusRatio: 0.490, ellipseAspect: 1.100, ellipseAngle: 0 },
    { id: 12, label: "Li", name: "Lion", assetId: "lion", assetCenter: [0.485, 0.495], imageBodyRadiusRatio: 0.502, ellipseAspect: 1.200, ellipseAngle: 0 },
    { id: 13, label: "E", name: "Elephant", assetId: "elephant", assetCenter: [0.500, 0.480], imageBodyRadiusRatio: 0.406, ellipseAspect: 1.100, ellipseAngle: 0 },
    { id: 14, label: "W", name: "Whale", assetId: "whale", assetCenter: [0.438, 0.509], imageBodyRadiusRatio: 0.388, ellipseAspect: 1.355, ellipseAngle: 0 },
    { id: 15, label: "Cc", name: "Cute Cat", assetId: "cute-cat", assetCenter: [0.470, 0.527], imageBodyRadiusRatio: 0.411, ellipseAspect: 0.985, ellipseAngle: 0 },
];
// keep this for reference
  // export const EVOLUTION_CHAIN = [
  //   { id: 0, label: "C", name: "Cell", assetId: "cell", assetCenter: [0.500, 0.546], imageBodyRadiusRatio: 0.495, ellipseAspect: 1.687, ellipseAngle: -3.1416 },
  //   { id: 1, label: "S", name: "Starfish", assetId: "starfish", assetCenter: [0.500, 0.567], imageBodyRadiusRatio: 0.345, ellipseAspect: 1.000, ellipseAngle: 0 },
  //   { id: 2, label: "J", name: "Jellyfish", assetId: "jellyfish", assetCenter: [0.510, 0.426], imageBodyRadiusRatio: 0.539, ellipseAspect: 1.475, ellipseAngle: 0 },
  //   { id: 3, label: "F", name: "Fish", assetId: "fish", assetCenter: [0.521, 0.540], imageBodyRadiusRatio: 0.497, ellipseAspect: 1.607, ellipseAngle: 0 },
  //   { id: 4, label: "Sn", name: "Snail", assetId: "snail", assetCenter: [0.507, 0.597], imageBodyRadiusRatio: 0.508, ellipseAspect: 1.615, ellipseAngle: 0 },
  //   { id: 5, label: "B", name: "Bug", assetId: "bug", assetCenter: [0.507, 0.568], imageBodyRadiusRatio: 0.480, ellipseAspect: 1.611, ellipseAngle: 0 },
  //   { id: 6, label: "Bf", name: "Butterfly", assetId: "butterfly", assetCenter: [0.500, 0.470], imageBodyRadiusRatio: 0.477, ellipseAspect: 1.467, ellipseAngle: -0.0647 },
  //   { id: 7, label: "L", name: "Lizard", assetId: "lizard", assetCenter: [0.474, 0.565], imageBodyRadiusRatio: 0.502, ellipseAspect: 2.000, ellipseAngle: 0.2823 },
  //   { id: 8, label: "P", name: "Pterodactyl", assetId: "pterodactyl", assetCenter: [0.510, 0.562], imageBodyRadiusRatio: 0.334, ellipseAspect: 1.400, ellipseAngle: 0 },
  //   { id: 9, label: "T", name: "T-rex", assetId: "trex", assetCenter: [0.417, 0.531], imageBodyRadiusRatio: 0.425, ellipseAspect: 1.258, ellipseAngle: 0.5076 },
  //   { id: 10, label: "A", name: "Alien", assetId: "alien", assetCenter: [0.500, 0.518], imageBodyRadiusRatio: 0.490, ellipseAspect: 1.100, ellipseAngle: 0 },
  //   { id: 11, label: "Li", name: "Lion", assetId: "lion", assetCenter: [0.485, 0.495], imageBodyRadiusRatio: 0.502, ellipseAspect: 1.200, ellipseAngle: 0 },
  //   { id: 12, label: "E", name: "Elephant", assetId: "elephant", assetCenter: [0.500, 0.480], imageBodyRadiusRatio: 0.406, ellipseAspect: 1.100, ellipseAngle: 0 },
  //   { id: 13, label: "W", name: "Whale", assetId: "whale", assetCenter: [0.438, 0.509], imageBodyRadiusRatio: 0.388, ellipseAspect: 1.355, ellipseAngle: 0 },
  //   { id: 14, label: "Cc", name: "Cute Cat", assetId: "cute-cat", assetCenter: [0.470, 0.527], imageBodyRadiusRatio: 0.411, ellipseAspect: 0.985, ellipseAngle: 0 },
  // ];
/** Active tier cap for merge evolution. Set lower than EVOLUTION_CHAIN length to limit progression. */
export const MAX_MERGE_EVOLUTION_TIERS = 11;
export function getActiveEvolutionTierCount() {
  var chain = EVOLUTION_CHAIN || [];
  var configured = MAX_MERGE_EVOLUTION_TIERS;
  if (configured == null) return chain.length;
  var parsed = Math.floor(Number(configured));
  if (!isFinite(parsed)) return chain.length;
  return Math.max(1, Math.min(chain.length, parsed));
}
export function getActiveEvolutionChain() {
  var chain = EVOLUTION_CHAIN || [];
  var activeCount = typeof getActiveEvolutionTierCount === "function"
    ? getActiveEvolutionTierCount()
    : chain.length;
  return chain.slice(0, activeCount);
}

export const RUN_SPAWN_MAX_TIER = 6;
/**
 * Runway + evolution baseline at the start of each run's first Fall (tier ids 0–2 = Cell, Starfish, Jellyfish).
 * currentGameMaxTier is seeded to RUN_START_MAX_TIER so all three can spawn on the opening Fall stage.
 */
export const RUN_START_MAX_TIER = 2;
/** Lifetime collection unlocks granted before the first catch of every run. */
export const RUN_START_UNLOCKED_TIER_IDS = [0, 1, 2];
/** Baseline ladder for tiers below currentGameMaxTier (see run/spawn-weights.js). */
export const TIER_SPAWN_WEIGHTS = [40, 30, 15, 8, 4, 2];
/** Weight for the newest unlocked tier on the Fall runway (rare). */
export const TIER_SPAWN_NEW_TIER_WEIGHT = 2;
/** Per-tier step multiplier for tiers below run max (higher = lower tiers dominate sooner). */
export const TIER_SPAWN_BOOST_PER_STEP = 1.35;
export const MERGE_PICKUP_COLORS = [
  "#94a3b8", "#a78bfa", "#f472b6", "#fb923c",
  "#4ade80", "#38bdf8", "#facc15", "#f43f5e",
  "#a855f7", "#ec4899", "#14b8a6", "#eab308",
  "#6366f1", "#84cc16", "#f97316", "#fb7185",
];

/** Sky background motion policy — see `docs/performance.md` § Sky auto mode. */
export const SKY_BACKGROUND_MODES = {
  AUTO: "auto",
  DYNAMIC: "dynamic",
  STATIC: "static",
};

/**
 * `sky_bg_resolved.sky_bg_resolve_source` values — see `docs/performance.md` § Sky auto mode.
 * `"probe"` is fail-only (low FPS on first-Fall countdown).
 */
export const SKY_BG_RESOLVE_SOURCES = {
  REDUCED_MOTION: "reduced_motion",
  LOW_MEMORY: "low_memory",
  PROBE: "probe",
  PROBE_PASS: "probe_pass",
  PERF_EPISODE: "perf_episode",
  /** Auto static → dynamic after a strong completed Fall→Merge cycle. */
  CYCLE_UPGRADE: "cycle_upgrade",
};

// ========== FALL STAGE CONFIG ==========
export const RUN_CONFIG = {
    REACTION_TIME_MIN: 2.0,
    REACTION_TIME_MAX: 2.2,
    BREATHING_SPACE_MIN: 0.5,
    BREATHING_SPACE_MAX: 1.2,
    RUN_DURATION: 20,
    RUN_SLOT_COUNT_MIN: 10,
    RUN_SLOT_COUNT_MAX: 14,
    MERGE_PICKUP_COUNT_MIN: 30,
    MERGE_PICKUP_COUNT_MAX: 50,
    /** Boulder (hazard) count per run. */
    BOULDER_COUNT_MIN: 6,
    BOULDER_COUNT_MAX: 10,
    GEM_CLUSTER_COUNT_MIN: 3,
    GEM_CLUSTER_COUNT_MAX: 6,
    GEMS_PER_CLUSTER: 3,
    GEM_CLUSTER_SPACING_PROGRESS: 0.008,
    BONUS_COUNT_MIN: 0,
    BONUS_COUNT_MAX: 2,
    HAZARD_HP_PENALTY: 0.15,
    /** Shield field materialize duration (ms). */
    SHIELD_APPEAR_MS: 280,
    /** Shield field break/dematerialize duration (ms). */
    SHIELD_DISAPPEAR_MS: 220,
    /** Starting scale for appear (scales down toward SHIELD_FIELD_SCALE). */
    SHIELD_APPEAR_SCALE: 1.22,
    /** Ending scale for disappear (scales up from SHIELD_FIELD_SCALE). */
    SHIELD_DISAPPEAR_SCALE: 1.22,
    /** Steady shield circle scale while active. */
    SHIELD_FIELD_SCALE: 1,
    /** Hex cell radius as a fraction of the shield circle radius. */
    SHIELD_HEX_SIZE_FRAC: 0.11,
    /** Keyboard move speed as fraction of run width per second. */
    PLAYER_MOVE_SPEED_RATIO: 0.6,
    /** Keyboard hold ramp: min speed as multiplier of base keyboard move speed. */
    PLAYER_KEYBOARD_MOVE_SPEED_MIN_RATIO: 1,
    /** Keyboard hold ramp: max speed as multiplier of base keyboard move speed. */
    PLAYER_KEYBOARD_MOVE_SPEED_MAX_RATIO: 2,
    /** Keyboard hold ramp duration (ms) from min to max speed. */
    PLAYER_KEYBOARD_MOVE_RAMP_MS: 1000,
    /** Minimum horizontal distance (0..1) between objects spawned at the same progress level. */
    RUNWAY_SAME_PROGRESS_MIN_GAP: 0.3,
    /** Horizontal side margin as fraction of run width (kept from run stage; no runway drawn). */
    RUNWAY_MARGIN: 0.1,
    POINTER_SENSITIVITY: 1.5,
    /** Countdown steps before the first Fall of a run (3, 2, 1). Later Falls in the same run use 0. */
    RUN_COUNTDOWN_SECONDS: 3,
    /**
     * Silent hold before spawns when booting from a checkpoint into a non-first Fall
     * (covers the game-loader dismiss so objects do not fall while the scrim is up).
     */
    FALL_RESUME_SPAWN_DELAY_SECONDS: 1,
    /** Wall-clock duration of each countdown step (ms). */
    FALL_COUNTDOWN_TICK_MS: 1000,
    /** Fall countdown peak font-size (px) at `--scale-side` 1; legacy fallback when play-column scale is unavailable. */
    FALL_COUNTDOWN_FONT_BASE_PX: 72,
    /** Peak countdown digit height as fraction of catcher flask height (`_getFlaskDims().flaskH`). */
    FALL_COUNTDOWN_FLASK_HEIGHT_RATIO: 0.6,
    /** Minimum pop scale at the start of each countdown second (0.35 was too small vs flask). */
    FALL_COUNTDOWN_POP_SCALE_MIN: 0.5,
    /** Peak score-popup font height as fraction of Fall countdown peak (0.5 ≈ 30% of flask height). */
    SCORE_POPUP_COUNTDOWN_HEIGHT_RATIO: 0.45,
    /** Catch flash duration in ms. */
    RUN_CATCH_FLASH_MS: 200,
    /** Time remaining (seconds) at which HUD shows warning color. */
    RUN_TIME_WARNING_AT: 5,
    /** Seconds from play start (after countdown) before first runway spawns; 0 = immediate. */
    RUN_TIME_TO_FIRST_ITEM_SECONDS: 0,
    /** Boulder object width as fraction of run width. */
    BOULDER_WIDTH_RATIO: 0.144,
    /** Gem object width as fraction of run width. */
    GEM_WIDTH_RATIO: 0.1,
    /** Shield bonus object width as fraction of run width (shield.png). */
    BONUS_WIDTH_RATIO: 0.12,
    /** Merge pickup object width as fraction of run width. No scale multiplier applied. */
    MERGE_PICKUP_WIDTH_RATIO: 0.12,
    /**
     * Phase I falling-object size multiplier (physics + draw). 1.0 = layout ratios only;
     * lower values shrink boulders, gems, bonuses, and merge pickups together.
     */
    FALL_OBJECT_SIZE_SCALE: 0.88,
    MERGE_PICKUP_MARGIN_RATIO: 0.04,
    MERGE_PICKUP_OFFSET_RATIO: 0.08,
    /** Duration (ms) to fade out fall BGM when the catch→shake bridge overlay appears. */
    RUN_BGM_FADE_OUT_ON_BRIDGE_MS: 1000,
    /** Duration (ms) to fade in shake BGM after fall BGM is off. */
    RUN_BGM_FADE_IN_ON_BRIDGE_MS: 1000,
    /** Max tail after Fall timer hits 0; ends early when the runway is visually idle. */
    FALL_SETTLE_MS: 2000,
    /** Delay (ms) before auto-transition from fall end to shake stage (legacy alias). */
    RUN_TO_SHAKE_TRANSITION_MS: 2000,
    /** Full celestial day↔night handoff duration (both directions). */
    DAY_NIGHT_TRANSITION_MS: 2000,
    /** Stage-only UI fade at each end of handoff. */
    STAGE_ELEMENT_FADE_MS: 300,
    /** Sky/sea background cache bucket (ms); redraw at most once per bucket while key matches. */
    SKY_SCENE_CACHE_BUCKET_MS: 132,
    /** Alias for SKY_SCENE_CACHE_BUCKET_MS (all stages and transitions). */
    SKY_SCENE_CACHE_CRAWL_BUCKET_MS: 132,
    /** Max sky-scene repaint rate (full drawSkyScene, not blit) for all stages and transitions. */
    SKY_SCENE_CACHE_MAX_FPS: 60,
    /** Minimum draw space above the Fall play column (actual value scales with object size). */
    FALL_DRAW_TOP_OVERFLOW_PX: 120,
    /** Spawn appear pop peak scale (ease-out-back overshoot cap for clip + spawn Y). */
    FALL_SPAWN_APPEAR_MAX_SCALE: 1.12,
    /** Spawn appear pop duration (ms) — scale-up + fade-in when object enters runway. */
    FALL_SPAWN_APPEAR_MS: 260,
    /** Gap between spawn appear peak and the play-column top edge (local Y = 0). */
    FALL_SPAWN_TOP_MARGIN_PX: 16,
    /** Runway spawn particle burst duration (ms). */
    FALL_SPAWN_PARTICLE_MS: 350,
    /** Runway spawn particle count per object (scaled up for large spawns). */
    FALL_SPAWN_PARTICLE_COUNT: 14,
    /** Reference half-extent (px) for sizing runway spawn bursts to object draw size. */
    FALL_SPAWN_PARTICLE_REF_HALF_PX: 18,
    /** Vertical motion streaks on falling objects (vector-only; no sprite shift-blur). */
    FALL_MOTION_TRAIL_ENABLED: true,
    /** Min speed |v| (Matter velocity) before a trail appears. */
    FALL_MOTION_TRAIL_MIN_VY: 2.5,
    /** Speed |v| at which the trail reaches full length. */
    FALL_MOTION_TRAIL_FULL_VY: 9,
    /** Trail length multiplier — lower = subtler (logo snapshot uses ~0.7). */
    FALL_MOTION_TRAIL_LENGTH_MUL: 0.16,
    /** Panel theme crossfade (day↔night chrome) at sunrise/sunset boundary. */
    STAGE_THEME_CROSSFADE_MS: 300,
    /** Shake sky hour at end of Fall→Shake timelapse. */
    SHAKE_SKY_CRAWL_START_HOUR: 16,
    /** Shake sky hour asymptotic crawl target. */
    SHAKE_SKY_CRAWL_TARGET_HOUR: 21,
    /** Time constant (ms) for Shake hour crawl toward target. */
    SHAKE_SKY_CRAWL_TAU_MS: 75000,
    /**
     * Sky motion preference: `auto` (probe on first Fall countdown), `dynamic`, or `static`.
     * Runtime effective mode is stored on `SKY_BACKGROUND_EFFECTIVE` by Game.
     */
    SKY_BACKGROUND_MODE: SKY_BACKGROUND_MODES.AUTO,
    /** Cap for probe FPS budget; actual threshold is min(display Hz, this). */
    SKY_AUTO_PROBE_FPS_THRESHOLD: 60,
    /** Ignore first ~1 s of probe samples (cold-start warmup). */
    SKY_AUTO_PROBE_WARMUP_MS: 1000,
    /** Max dropped-frame ratio after warmup (frameMs > budget). Null p95 uses budget × 1.25. */
    SKY_AUTO_PROBE_DROPPED_FRAME_RATIO_MAX: 0.15,
    /** Optional fixed frame-time p95 cap (ms); null = derive from FPS threshold. */
    SKY_AUTO_PROBE_FRAME_MS_P95_MAX: null,
    /**
     * Post-probe static→dynamic upgrade: max dropped-frame ratio over a completed
     * Fall→Merge cycle (stricter than `SKY_AUTO_PROBE_DROPPED_FRAME_RATIO_MAX`).
     */
    SKY_CYCLE_UPGRADE_DROPPED_FRAME_RATIO_MAX: 0.08,
    /** p95 frame budget multiplier vs display Hz (stricter than probe's 1.25). */
    SKY_CYCLE_UPGRADE_P95_BUDGET_MULT: 1.1,
    /** Ignore first ~1 s of each cycle sample window. */
    SKY_CYCLE_UPGRADE_WARMUP_MS: 1000,
    /** Minimum post-warmup frames before a cycle may upgrade to dynamic. */
    SKY_CYCLE_UPGRADE_MIN_FRAME_SAMPLES: 300,
    /** Static mode: sun hour held through Fall (countdown, play, settle) per cycle. */
    STATIC_FALL_HOLD_HOUR: 5,
    /** Static mode: moon hour held through Shake until NEXT DAY. */
    STATIC_SHAKE_HOLD_HOUR: 19,
    /** Delay (ms) after declining revive before run failure/game over. */
    RUN_FLASK_SHATTER_TO_GAME_OVER_MS: 2000,
    /**
     * Live revives per run (Fall shatter or Merge overflow — one shared budget).
     * The free one is offered first and costs nothing; the ad one is offered after it is
     * spent, and only where rewarded ads exist. Builds without ads get the free one only.
     */
    REVIVE_FREE_PER_RUN: 1,
    REVIVE_AD_PER_RUN: 1,
    /** Fall revive restores catcher flask to this many HP. */
    REVIVE_FALL_RESTORE_HP: 1,
    /** Ms to keep Fall sim running after shatter before pause + revive popup. */
    REVIVE_OFFER_GRACE_MS: 2000,
    /** @deprecated Fall movement hint is per-run (first Fall day only); key unused. */
    RUN_MOVEMENT_HINT_KEY: "mT1iHv5n",
};

/**
 * Merge pickup count multiplier by Fall day (`cycleIndex` 0 = day 1).
 * Values apply to `MERGE_PICKUP_COUNT_MIN/MAX` after profile overrides; day 3+ uses the last entry.
 */
export const FALL_MERGE_PICKUP_RAMP = [0.8, 0.9, 1.0];

/**
 * Rotating Fall loot profiles for `cycleIndex >= 1` (second Fall onward in a run).
 * Day 1 uses a tutorial overlay (no boulders/shields) instead of these ids.
 * Each profile overrides spawn ranges; omitted keys keep `RUN_CONFIG` defaults.
 */
export const FALL_PHASE_PROFILES = [
  {
    id: "steady",
    BOULDER_COUNT_MIN: 6,
    BOULDER_COUNT_MAX: 9,
    GEM_CLUSTER_COUNT_MIN: 3,
    GEM_CLUSTER_COUNT_MAX: 5,
    BONUS_COUNT_MIN: 0,
    BONUS_COUNT_MAX: 2,
  },
  {
    id: "gem_rush",
    BOULDER_COUNT_MIN: 4,
    BOULDER_COUNT_MAX: 7,
    GEM_CLUSTER_COUNT_MIN: 5,
    GEM_CLUSTER_COUNT_MAX: 7,
    BONUS_COUNT_MIN: 0,
    BONUS_COUNT_MAX: 1,
  },
  {
    id: "rock_storm",
    BOULDER_COUNT_MIN: 9,
    BOULDER_COUNT_MAX: 12,
    GEM_CLUSTER_COUNT_MIN: 2,
    GEM_CLUSTER_COUNT_MAX: 4,
    BONUS_COUNT_MIN: 0,
    BONUS_COUNT_MAX: 1,
  },
  {
    id: "shield_blessed",
    BOULDER_COUNT_MIN: 5,
    BOULDER_COUNT_MAX: 8,
    GEM_CLUSTER_COUNT_MIN: 3,
    GEM_CLUSTER_COUNT_MAX: 5,
    BONUS_COUNT_MIN: 2,
    BONUS_COUNT_MAX: 3,
  },
  {
    id: "gem_bounty",
    BOULDER_COUNT_MIN: 5,
    BOULDER_COUNT_MAX: 8,
    GEM_CLUSTER_COUNT_MIN: 5,
    GEM_CLUSTER_COUNT_MAX: 7,
    BONUS_COUNT_MIN: 1,
    BONUS_COUNT_MAX: 2,
  },
  {
    id: "lean_pickings",
    BOULDER_COUNT_MIN: 7,
    BOULDER_COUNT_MAX: 10,
    GEM_CLUSTER_COUNT_MIN: 2,
    GEM_CLUSTER_COUNT_MAX: 3,
    BONUS_COUNT_MIN: 0,
    BONUS_COUNT_MAX: 1,
  },
];

// ========== SHARED FRAME TIMING / SIM STABILITY ==========
/** Clamp any single frame step to avoid giant simulation jumps after stalls. */
export const MAX_FRAME_DELTA_MS = 100;
/** Preferred fixed simulation step for Stage I physics substepping. */
export const FALL_PHYSICS_STEP_MS = 1000 / 60;
  /** Maximum number of Stage I physics substeps per rendered frame. */
export const FALL_PHYSICS_MAX_SUBSTEPS = 6;
  /** Preferred fixed simulation step for Stage II flask physics substepping. */
/** Max device pixel ratio for the main board and sky offscreen caches. */
export const CANVAS_MAX_DPR = 2;

export const FLASK_PHYSICS_STEP_MS = 1000 / 60;
/** Sealed physics steps after Fall→Merge body migration so inherited runway motion does not drift in. */
export const FLASK_HANDOFF_SETTLE_MS = 900;
  /** Maximum number of Stage II physics substeps per rendered frame. */
export const FLASK_PHYSICS_MAX_SUBSTEPS = 6;
/** Extra substep cap while the pile is moving or in a containment burst (shake, drop, merge). */
export const FLASK_PHYSICS_BURST_MAX_SUBSTEPS = 14;
/** Reference flask panel height for scaling legacy fixed physics px (~Shake jar at ref layout). */
export const FLASK_PHYSICS_REF_HEIGHT_PX = 400;
/** Max upward speed at mouth — fraction of panel height (~6 px/update @ 400px jar). */
export const FLASK_MOUTH_MAX_UPWARD_SPEED_FRAC = 0.015;
/** @deprecated Use {@link FLASK_MOUTH_MAX_UPWARD_SPEED_FRAC}; kept for docs/tests at ref height. */
export const FLASK_MOUTH_MAX_UPWARD_SPEED = 6;
/** Rim damp band below visual top — fraction of panel height (~2px @ 400px). */
export const FLASK_MOUTH_DAMP_SLACK_FRAC = 0.005;
/** @deprecated Use {@link FLASK_MOUTH_DAMP_SLACK_FRAC}. */
export const FLASK_MOUTH_DAMP_SLACK_PX = 2;
/** Predictive mouth breach sweep multiplier (only when already at the rim). */
export const FLASK_MOUTH_SWEEP_FACTOR = 1.1;
/** Min rim overshoot before hard mouth clamp — fraction of height (~8px @ 400px). */
export const FLASK_MOUTH_OVERSHOOT_MIN_FRAC = 0.02;
/** @deprecated Use {@link FLASK_MOUTH_OVERSHOOT_MIN_FRAC}. */
export const FLASK_MOUTH_OVERSHOOT_PX = 8;
export const FLASK_MOUTH_OVERSHOOT_HALF_MULT = 0.5;
/** Floor half-width minimum — fraction of min(panel w, h) (~8px @ 400px). */
export const FLASK_FLOOR_HALF_MIN_FRAC = 0.02;
/** Drop splash fizz — fractions of panel height (tuned @ {@link FLASK_PHYSICS_REF_HEIGHT_PX}). */
export const FLASK_DROP_SPLASH_SPEED_FRAC = 0.0075;
export const FLASK_DROP_SPLASH_RADIUS_FRAC = 0.01;
export const FLASK_DROP_SPLASH_VEL_SCALE_FRAC = 0.075;
export const FLASK_DROP_SPLASH_GRAVITY_FRAC = 0.2;
/** Stage II merge animal bodies — rubbery grip so rolls lose energy (ice-low values slide/spin forever). */
export const FLASK_MERGE_BODY_RESTITUTION = 0.2;
export const FLASK_MERGE_BODY_FRICTION = 0.4;
/** Coulomb static multiplier (Matter: pair limit is friction × frictionStatic). */
export const FLASK_MERGE_BODY_FRICTION_STATIC = 1;
export const FLASK_MERGE_BODY_FRICTION_AIR = 0.01;
/** First-impact bounce for a released drop only; settled bodies keep {@link FLASK_MERGE_BODY_RESTITUTION}. */
export const FLASK_DROP_LANDING_RESTITUTION = 0.52;
/**
 * Optional extra downward Matter step velocity on release (fraction of jar height).
 * 0 = gravity-only fall from the rim; a small bounce still comes from landing restitution.
 */
export const FLASK_DROP_LANDING_VY_FRAC = 0;
/** Allowed overlap before separation (lower = less ball–ball sticking). */
export const FLASK_MERGE_BODY_SLOP = 0.02;
/** Matter.js position solver iterations for Stage II flask (Fall uses 8). */
export const FLASK_PHYSICS_POSITION_ITERATIONS = 14;
/** Matter.js constraint solver iterations for Stage II flask (Fall uses 4). */
export const FLASK_PHYSICS_CONSTRAINT_ITERATIONS = 10;
/** Run wall/mouth containment every N frames when the flask pile is settled. */
export const FLASK_CONTAINMENT_CHECK_INTERVAL = 5;
/** After shake, drop, merge, or removal — run containment every frame for this long (ms). */
export const FLASK_CONTAINMENT_BURST_MS = 700;
/** Body speed above this (at {@link FLASK_PHYSICS_REF_HEIGHT_PX}) keeps containment at full rate. */
export const FLASK_CONTAINMENT_ACTIVE_SPEED = 0.35;
/** Faster “pile is moving” threshold used during burst substepping, at ref jar height. */
export const FLASK_CONTAINMENT_BURST_SPEED = 1.2;
/** Physics mouth gate / ceiling sits this fraction of inner jar height above the visual rim (bounds.top). */
export const FLASK_MOUTH_GATE_RAISE_FRAC = 0.05;
/** @deprecated Extra extend merged into {@link FLASK_MOUTH_GATE_RAISE_FRAC} — kept at 0. */
export const FLASK_PHYSICS_WALL_EXTEND_UP_FRAC = 0;
/** Merge drop spawn inset below bounds.top as a fraction of flask height (~8px at 400px jar). */
export const FLASK_DROP_SPAWN_OFFSET_FRAC = 0.02;
/**
 * Merge drop: lift physics spawn toward the DOM aim, as a fraction of sprite height.
 * Larger sprites (fish, snail) spawn higher; small tiers stay near the rim line.
 */
export const FLASK_DROP_SPAWN_AIM_LIFT_FRAC = 0.25;
  // ========== FALL STAGE PHYSICS ==========
  /** Matter.js gravity y for the fall stage at {@link FALL_GRAVITY_REF_RUN_HEIGHT_PX}. */
export const FALL_GRAVITY = 0.68;
  /** Reference play-column height (grid unit 120 × 4.5) — gravity scales with actual run height. */
export const FALL_GRAVITY_REF_RUN_HEIGHT_PX = 540;
  /**
   * Extra gravity cut when the board is shorter than the ref height.
   * Linear `h/ref` already keeps fall *time* constant; a small preview still
   * *feels* rushed (harder tracking, unscaled motion-blur thresholds). This
   * eases gravity further so hang time grows as the window shrinks.
   * 0 = time-constant only; 1 = gravity ∝ (h/ref)² on small boards.
   */
export const FALL_GRAVITY_SMALL_SCREEN_EASE = 0.28;
  /** Spawn band margin above the play clip as a fraction of run height (≈16px at ref height). */
export const FALL_SPAWN_TOP_MARGIN_RUN_HEIGHT_RATIO = 0.03;

/**
 * @param {number} runHeightPx
 * @param {object} [runConfig]
 */
export function getFallGravityForRunHeight(runHeightPx, runConfig) {
  var rc = runConfig || {};
  var base = rc.FALL_GRAVITY != null ? Number(rc.FALL_GRAVITY) : FALL_GRAVITY;
  if (!isFinite(base) || base <= 0) base = FALL_GRAVITY;
  var ref = rc.FALL_GRAVITY_REF_RUN_HEIGHT_PX != null
    ? Number(rc.FALL_GRAVITY_REF_RUN_HEIGHT_PX)
    : FALL_GRAVITY_REF_RUN_HEIGHT_PX;
  if (!isFinite(ref) || ref <= 0) ref = FALL_GRAVITY_REF_RUN_HEIGHT_PX;
  var h = Math.max(1, Number(runHeightPx) || 1);
  var linear = h / ref;
  var feel = 1;
  if (linear < 1) {
    var ease = rc.FALL_GRAVITY_SMALL_SCREEN_EASE != null
      ? Number(rc.FALL_GRAVITY_SMALL_SCREEN_EASE)
      : FALL_GRAVITY_SMALL_SCREEN_EASE;
    if (!isFinite(ease) || ease < 0) ease = 0;
    if (ease > 1) ease = 1;
    feel = 1 - ease * (1 - linear);
  }
  return base * linear * feel;
}

/**
 * @param {number} runHeightPx
 * @param {object} [runConfig]
 */
export function getFallSpawnTopMarginPx(runHeightPx, runConfig) {
  var rc = runConfig || {};
  var ratio = rc.FALL_SPAWN_TOP_MARGIN_RUN_HEIGHT_RATIO != null
    ? Number(rc.FALL_SPAWN_TOP_MARGIN_RUN_HEIGHT_RATIO)
    : FALL_SPAWN_TOP_MARGIN_RUN_HEIGHT_RATIO;
  if (!isFinite(ratio) || ratio < 0) ratio = FALL_SPAWN_TOP_MARGIN_RUN_HEIGHT_RATIO;
  var h = Math.max(0, Number(runHeightPx) || 0);
  if (h > 0) return h * ratio;
  var px = rc.FALL_SPAWN_TOP_MARGIN_PX != null ? Number(rc.FALL_SPAWN_TOP_MARGIN_PX) : 16;
  return isFinite(px) && px >= 0 ? px : 16;
}
  /** Duration (ms) of the fade-shrink suction animation before the object is collected. */
export const FALL_SUCTION_ANIMATION_MS = 50;
  /**
   * Height (px) of the dedicated collection sensor slab that spans the flask mouth
   * entrance. Collectibles (gems/shield/merge pickups) are collected only when they
   * overlap this thin slab; interpolated (swept) detection catches fast objects that
   * would otherwise tunnel through it between frames.
   */
export const FALL_COLLECT_SLAB_HEIGHT_PX = 12;
  /** Downward shift of the mouth collection slab from the visual rim (px). Positive = lower. */
export const FALL_COLLECT_SLAB_Y_OFFSET_PX = 0;
  /** Angular velocity impulse applied on Stage I side-wall bounces. */
export const FALL_SIDE_BOUNCE_SPIN = 0.16;
  /** Max absolute random angular velocity assigned to spawned boulder debris. */
export const FALL_DEBRIS_SPAWN_SPIN_MAX = 0.25;
  /** Max spawn spin for boulders and merge pickups (± degrees per second). */
export const FALL_OBJECT_SPAWN_SPIN_MAX_DEG_PER_S = 60;

  // ========== STAGE II — SHAKE ECONOMY ==========
export const SHAKE_USES_DEFAULT = 3;
/** Coach-mark: wait this long after Shake start / a drop before showing "Shake it". */
export const SHAKE_HINT_SETTLE_MS = 3000;
/** Lowest merge tier that can trigger the SHAKE coach-mark (2 = jellyfish). */
export const SHAKE_HINT_MIN_TIER = 2;
/** Tooltip wiggle cadence — same 3 s repeat as NEXT DAY / DROP ALL. */
export const SHAKE_HINT_WIGGLE_REPEAT_MS = 3000;
/** Tooltip wiggle length — same 520 ms shake as `continue-btn-wiggle`. */
export const SHAKE_HINT_WIGGLE_ANIM_MS = 520;
/** Tooltip fade in/out when the coach-mark appears or leaves. */
export const SHAKE_HINT_FADE_MS = 280;
  /** Secret Evolution Dock prompt: exact "MAX" grants this many free shakes in Stage II. */
export const EVOLUTION_DOCK_MAX_CHEAT_SHAKES = 1000;
/** Evolution dock cheat `PAVLO`: gems granted per use. */
export const EVOLUTION_DOCK_PAVLO_CHEAT_GEMS = 1000;
/** Evolution dock cheat `NASTYA`: pterodactyls added to shake drop queue per use. */
export const EVOLUTION_DOCK_NASTYA_CHEAT_PTERODACTYLS = 8;
/** Bonus score when two max-tier dragons merge (capped self-merge). */
export const DRAGON_MERGE_SCORE_BONUS = 300000;
export const BOMB_USES_DEFAULT = 0;
  /** Free cell-tier removes before paid gem cost (BOMB_CELL_COST). */
export const BOMB_CELL_USES_DEFAULT = 1;
  /** Free first-three-tier clears granted to new players (lifetime stock). */
export const BOMB_THREE_TIER_USES_DEFAULT = 1;
  /** Cost per paid shake once free shakes are depleted. */
export const SHAKE_USE_COST = 5;
  /** Gem cost for hidden cell-tier remove after free stock. */
export const BOMB_CELL_COST = 10;
  /** Gem cost for three-tier clear after free stock. */
export const BOMB_THREE_TIER_COST = 10;
  /** Legacy single-bomb cost retained for older tests/tools. */
export const BOMB_USE_COST = BOMB_THREE_TIER_COST;
  /** Cost to repair flask by +1 HP during shake stage. */
export const FLASK_FIX_COST = 10;
  /** Free shrink actions for new players (lifetime stock); then MINIMIZE_COST gems per use. */
export const MINIMIZE_USES_DEFAULT = 1;
export const MINIMIZE_COST = 50;
  /** Minimum physics size tier when shrinking (0 = cell); identity tier is unchanged. */
export const MINIMIZE_PHYSICS_SIZE_TIER = 0;
  /** Each shrink reduces physics size by this many evolution tiers (floor = MINIMIZE_PHYSICS_SIZE_TIER). */
export const MINIMIZE_PHYSICS_TIER_STEP = 4;
  /** Higher = stronger shake kicks on flask bodies (`FlaskSystem.applyShake`). */
export const SHAKE_IMPULSE_STRENGTH = 0.42;
/**
 * Matter velocity (px per 60fps step) per 1.0 of {@link SHAKE_IMPULSE_STRENGTH}
 * at {@link FLASK_PHYSICS_REF_HEIGHT_PX} (intensity and tier multipliers = 1).
 * Tuned so a moderate cell kick sits near the original 10 px/step cap at ref height
 * (~6× quieter than the uncapped ~71 laptop kick).
 */
export const SHAKE_IMPULSE_SPEED = 20;
/** Impulse magnitude multiplier at tier 0 (cells / small physics size react hardest). */
export const SHAKE_SMALL_TIER_IMPULSE_MULT = 1.75;
/**
 * Impulse at max evolution / physics size. Weaker than cells, but still a real toss —
 * ease-out (not linear lerp) is what keeps T-rex from matching the small-body launch.
 */
export const SHAKE_LARGE_TIER_IMPULSE_MULT = 0.38;
/**
 * Ease-out exponent for size→kick. 2 = quadratic: T-rex sits near
 * {@link SHAKE_LARGE_TIER_IMPULSE_MULT} instead of a linear 90% mix.
 */
export const SHAKE_TIER_IMPULSE_EASE = 2;
/** Large bodies keep this fraction of {@link SHAKE_IMPULSE_ANGLE_SPREAD_DEG} (cells keep 1). */
export const SHAKE_LARGE_TIER_SPREAD_FRAC = 0.55;
/** Base impulse direction is upward; each body gets ± this many degrees at tier-scaled magnitude. */
export const SHAKE_IMPULSE_ANGLE_SPREAD_DEG = 55;
/** Per-body kick jitter as a fraction of mag (± this, so 0.22 → 78%–122%). */
export const SHAKE_KICK_JITTER_FRAC = 0.22;

/**
 * 0 = cell-sized, 1 = max chain / physics size. Ease-out so T-rex is nearly “large”.
 * @param {number} sizeTier physics size tier (`physicsSizeTier`)
 * @param {number} maxTierIdx `evolutionChain.length - 1`
 */
export function getShakeTierEase(sizeTier, maxTierIdx) {
  var maxIdx = Math.max(1, Number(maxTierIdx) || 1);
  var t = Number(sizeTier);
  if (!isFinite(t)) t = 0;
  t = Math.min(1, Math.max(0, t / maxIdx));
  var p = SHAKE_TIER_IMPULSE_EASE != null ? Number(SHAKE_TIER_IMPULSE_EASE) : 2;
  if (!isFinite(p) || p < 1) p = 2;
  return 1 - Math.pow(1 - t, p);
}

/**
 * Size-scaled shake magnitude multiplier (small pop hardest; T-rex / dragon toss lighter).
 * @param {number} sizeTier physics size tier (`physicsSizeTier`)
 * @param {number} maxTierIdx `evolutionChain.length - 1`
 */
export function getShakeTierImpulseMul(sizeTier, maxTierIdx) {
  var small = SHAKE_SMALL_TIER_IMPULSE_MULT != null ? Number(SHAKE_SMALL_TIER_IMPULSE_MULT) : 1.75;
  var large = SHAKE_LARGE_TIER_IMPULSE_MULT != null ? Number(SHAKE_LARGE_TIER_IMPULSE_MULT) : 0.38;
  if (!isFinite(small) || small < 0) small = 1.75;
  if (!isFinite(large) || large < 0) large = 0.38;
  return small + (large - small) * getShakeTierEase(sizeTier, maxTierIdx);
}

/**
 * Immediate Matter velocity added by one shake kick (scales with jar height).
 * @param {number} strength {@link SHAKE_IMPULSE_STRENGTH}
 * @param {number} intensityMul moderate/strong/heavy roll
 * @param {number} tierMul small→large tier multiplier
 * @param {number} panelScale {@link getFlaskPanelScale}
 */
export function getShakeKickSpeed(strength, intensityMul, tierMul, panelScale) {
  var s = Number(strength);
  if (!isFinite(s) || s < 0) s = SHAKE_IMPULSE_STRENGTH;
  var im = Number(intensityMul);
  if (!isFinite(im) || im < 0) im = 1;
  var tm = Number(tierMul);
  if (!isFinite(tm) || tm < 0) tm = 1;
  var ps = Number(panelScale);
  if (!isFinite(ps) || ps <= 0) ps = 1;
  var unit = SHAKE_IMPULSE_SPEED != null ? Number(SHAKE_IMPULSE_SPEED) : 20;
  if (!isFinite(unit) || unit <= 0) unit = 20;
  return s * im * tm * ps * unit;
}
export const BOMB_REMOVE_COUNT = 10;

  // ========== SCORE ==========
  /** Base score for catching a merge pickup; multiplied by tier + 1. */
export const SCORE_MERGE_CATCH_BASE = 50;
  /** Base score for a successful merge; multiplied by 2^created tier. */
export const SCORE_MERGE_BASE = 100;

  // ========== FLASK PHYSICS / GEOMETRY ==========
  /** Matter.js gravity y for the merge jar at {@link FLASK_PHYSICS_REF_HEIGHT_PX}. */
export const FLASK_GRAVITY = 0.8;

/**
 * Scale merge gravity with jar height (same pattern as {@link getFallGravityForRunHeight}).
 * @param {number} panelHeightPx
 * @param {object} [runConfig]
 */
export function getFlaskGravityForPanelHeight(panelHeightPx, runConfig) {
  var rc = runConfig || {};
  var base = rc.FLASK_GRAVITY != null ? Number(rc.FLASK_GRAVITY) : FLASK_GRAVITY;
  if (!isFinite(base) || base <= 0) base = FLASK_GRAVITY;
  var ref = rc.FLASK_PHYSICS_REF_HEIGHT_PX != null
    ? Number(rc.FLASK_PHYSICS_REF_HEIGHT_PX)
    : FLASK_PHYSICS_REF_HEIGHT_PX;
  if (!isFinite(ref) || ref <= 0) ref = FLASK_PHYSICS_REF_HEIGHT_PX;
  var h = Math.max(1, Number(panelHeightPx) || 1);
  return base * (h / ref);
}
/** Software wall clamp: horizontal/floor velocity reflection factor (anti-tunneling). */
export const FLASK_WALL_CONTAINMENT_BOUNCE = 0.52;
/** When a body slides down a side wall, convert this fraction of downward speed into outward kick. */
export const FLASK_WALL_GLANCE_FACTOR = 0.18;
export const FLASK_MERGE_FLASH_MS = 160;
export const FLASK_MERGE_PARTICLE_MS = 620;
export const FLASK_MERGE_PARTICLE_COUNT = 18;
/** Reference body radius (px) for scaling flask merge burst particles. */
export const FLASK_MERGE_PARTICLE_REF_HALF_PX = 14;
/** Fastest merge sparks should reach at least this multiple of the new tier body radius. */
export const FLASK_MERGE_PARTICLE_OUTWARD_RADIUS_MULT = 2.1;
/** Extra velocity scale on flask merge bursts (size scale still drives dot radius). */
export const FLASK_MERGE_PARTICLE_SPEED_SCALE = 1;
/** Slower canvas drift than runway spawn bursts — pairs with longer FLASK_MERGE_PARTICLE_MS. */
export const FLASK_MERGE_PARTICLE_DRAW_VELOCITY = 16;
export const FLASK_MERGE_PARTICLE_GRAVITY = 24;
/** >1 keeps merge sparks bright longer before fade-out. */
export const FLASK_MERGE_PARTICLE_FADE_POWER = 1.5;
/** Mix tier tint toward white for flask merge dots/sparks. */
export const FLASK_MERGE_PARTICLE_BRIGHTEN = 0.42;
export const FLASK_MERGE_PARTICLE_ALPHA_MIN = 0.9;
export const FLASK_MERGE_PARTICLE_ALPHA_MAX = 1;
/** Merge attract + grow motion before bodies combine (ms). */
export const MERGE_MOTION_MS = 200;
/** Shrink size tween + ghost outline (defaults to MERGE_MOTION_MS). */
export const MINIMIZE_MOTION_MS = 200;
export const FLASK_DROP_SPLASH_MS = 400;
export const FLASK_DROP_PARTICLE_COUNT = 12;
  /** Min ms before the next aimed piece can drop (queue-to-preview charge). */
export const FLASK_DROP_NEXT_DELAY_MS = 300;
  /** Canvas NEXT tube glass width as fraction of column width (matches `drawCanvasTestTubeColumn`). */
export const FLASK_DROP_QUEUE_TUBE_WIDTH_FRAC = 0.72;
export const FLASK_DROP_QUEUE_TUBE_WIDTH_MIN_PX = 44;
export const FLASK_DROP_QUEUE_TUBE_WIDTH_MAX_PX = 70;
  /** Drop-queue preview icon radius: scales to tube width, clamped for readability. */
export const FLASK_DROP_QUEUE_PREVIEW_RADIUS_MIN_PX = 16;
export const FLASK_DROP_QUEUE_PREVIEW_RADIUS_MAX_PX = 26;
export const FLASK_DROP_QUEUE_PREVIEW_TUBE_FILL = 0.76;
export const FLASK_DROP_QUEUE_ROW_GAP_PX = 6;
  /** Canvas NEXT tube: vertical band reserved at the physical tube bottom for "+N" (does not steal icon rows). */
export const FLASK_DROP_QUEUE_OVERFLOW_BAND_PX = 24;
  /** Canvas NEXT tube "+N" label font size (px). */
export const FLASK_DROP_QUEUE_OVERFLOW_FONT_PX = 15;
  /** Merge drop mode: panel px above `flaskBounds.top` for preview + queue click hits. */
export const FLASK_DROP_ZONE_ABOVE_PX = 90;
  /** Boost drop mode (Stage II): horizontal aim speed when holding ArrowLeft/ArrowRight (px/s). */
export const DROP_AIM_KEYBOARD_SPEED = 350;
  /** Stage II CONTINUE: ms after the button enables before the first attention wiggle. */
export const SHAKE_CONTINUE_WIGGLE_INITIAL_DELAY_MS = 2000;
  /** Stage II CONTINUE: ms between repeat wiggles while still enabled and unclicked. */
export const SHAKE_CONTINUE_WIGGLE_REPEAT_MS = 3000;
  /** Stage II CONTINUE: duration of one wiggle CSS animation (ms). */
export const SHAKE_CONTINUE_WIGGLE_ANIM_MS = 520;
  /** Drop all: ms between auto-poured pieces. */
export const SHAKE_DROP_ALL_INTERVAL_MS = 100;
  /** Drop all: min gap from the previous drop X, as a fraction of the tier's usable width. */
export const SHAKE_DROP_ALL_MIN_SEPARATION_FRAC = 0.35;
  /** Drop all: random X candidates sampled before falling back to the farthest one. */
export const SHAKE_DROP_ALL_CANDIDATE_SAMPLES = 8;

/**
 * DEV ONLY — Fall speed toggle in the dev test bar. Index into this list is persisted so a
 * page refresh replays the next Fall at the chosen speed. Never read in production builds.
 */
export const DEV_FALL_SPEED_MULTIPLIERS = [1, 0.5, 0.25];
/** Button face per speed step. */
export const DEV_FALL_SPEED_LABELS = ["›", "››", "›››"];
/** Plain localStorage key — deliberately outside StorageSlot so Reset Progress cannot clear it. */
export const DEV_FALL_SPEED_STORAGE_KEY = "catchnmerge_dev_fall_speed";
/** Shake drop queue pill fade when queue empties (ms). */
export const DROP_QUEUE_PANEL_FADE_MS = 200;
/** Shake: mini queue icon → rim handoff (ms). */
export const DROP_QUEUE_HANDOFF_MS = 150;
/** Shake HP bar hide delay after healing to full (ms). */
export const SHAKE_HP_HIDE_AFTER_FULL_MS = 1000;
/** Shake HP bar fade-out duration (ms). */
export const SHAKE_HP_FADE_OUT_MS = 300;
/** Merge HP pill heartbeat cycle when damaged and visible (ms); one lub-dub per cycle. */
export const SHAKE_HP_HEARTBEAT_MS = 4000;
/** When only one heart is missing, interval is multiplied (less urgent). */
export const SHAKE_HP_HEARTBEAT_LOW_URGENCY_MULT = 2;
/** SHAKE click jar graphic L↔R vibration (ms). */
export const SHAKE_FLASK_GRAPHIC_SHAKE_MS = 260;
/** SHAKE click jar graphic amplitude at {@link FLASK_PHYSICS_REF_HEIGHT_PX}. */
export const SHAKE_FLASK_GRAPHIC_SHAKE_PX = 14;
/** Stash badge bounce duration (ms). */
export const STASH_BOUNCE_MS = 280;
/** Action button free→paid badge crossfade (ms). */
export const ACTION_BADGE_CROSSFADE_MS = 350;
  /** Warning zone line: fraction of flask interior height below bounds.top (0.05 = 5%; former alert line). */
export const FLASK_OVERFLOW_CHECK_BELOW_TOP_RATIO = 0.05;
  /** @deprecated Warning no longer uses fill ratio — kept for legacy callers. */
export const FLASK_OVERFLOW_NEAR_FULL_RATIO = 0.8;
  /** Per-body immunity after spawn before counting toward zones (ms). */
export const FLASK_OVERFLOW_BODY_IMMUNITY_MS = 2000;
  /** Warning UI after warning zone continuously occupied (ms). */
export const FLASK_OVERFLOW_WARNING_TRIGGER_MS = 1000;
  /** Alert UI after alert zone continuously occupied (ms). */
export const FLASK_OVERFLOW_ALERT_TRIGGER_MS = 2000;
  /** Game over after alert state sustained (ms). */
export const FLASK_OVERFLOW_LOSS_DWELL_MS = 7000;
  /** Zone clear debounce — jitter tolerance (ms). */
export const FLASK_OVERFLOW_ZONE_CLEAR_GRACE_MS = 100;
  /** Overflow warning rim-outline pulse period (ms). */
export const FLASK_OVERFLOW_WARN_BLINK_MS = 1400;
  /** Overflow alert rim-outline pulse period (ms) — faster than warning. */
export const FLASK_OVERFLOW_OUTLINE_ALERT_PULSE_MS = 760;
  /** Per-body overflow glow fade in/out duration (ms). */
export const FLASK_OVERFLOW_GLOW_FADE_MS = 300;
  /** Per-body overflow glow orange→red colour transition duration (ms). */
export const FLASK_OVERFLOW_GLOW_COLOR_MS = 300;
  /** Flask wall thickness as a fraction of the current flask bounds' smaller side. Keeps mini/big proportions identical. */
export const FLASK_WALL_THICKNESS_BOUNDS_RATIO = 0.045;
  /**
   * Fall landscape mini-flask: extra pixels around `layout.flaskBounds` for the canvas clip that wraps
   * `_strokeFlaskWallOutlines` + `FlaskSystem.draw` so neon `shadowBlur` is not cut off at the inner viewport edge.
   */
export const FLASK_MINI_VIEWPORT_CLIP_PAD_PX = 28;
  /**
   * Landscape narrow column width as a fraction of full canvas width (legacy constant;
   * responsive grid layout uses `layout/responsive-board.js` instead).
   */
export const SHAKE_RUN_FLASK_SPLIT = 0.32;
  /**
   * Landscape Stage II only: fixed-width strip between the shake UI column and the flask canvas.
   * Boost-queue “NEXT” previews draw here so the flask uses the full remaining width (walls align with play).
   */
export const SHAKE_NEXT_COLUMN_WIDTH = 88;
  /**
   * Stage II only: multiplier applied to `SHAKE_NEXT_COLUMN_WIDTH` for the canvas/DOM NEXT strip.
   * The extra width is taken from the shake UI column; flask play bounds stay unchanged.
   */
export const SHAKE_NEXT_COLUMN_WIDTH_SCALE = 1.5;
  /**
   * Stage II only: extra flask-panel width (px) taken from the shake UI column.
   * Flask play bounds (physics/draw size) stay unchanged — only panel chrome/margins grow.
   */
export const SHAKE_FLASK_PANEL_EXTRA_WIDTH_PX = 28;
/**
 * Landscape Fall only: shift `layout.flaskBounds` and the shared gameplay card down by this amount (px).
 */
export const FALL_GAMEPLAY_ROW_NUDGE_DOWN_PX = 8;
export const FALL_TOP_HUD_HEIGHT_PX = 48;
/** Default BGM volume (0–1) when no saved settings exist. */
export const DEFAULT_BGM_VOLUME = 0.2;
/** Default one-shot SFX volume (0–1) when no saved settings exist. */
export const DEFAULT_SFX_VOLUME = 0.8;
/** Per-sound gain multipliers applied on top of `sfxVolume` (clamped to 0–1). */
export const SFX_GAIN_BY_SOUND = {
  shrink: 2.5,
};
export { SOUND_SETTINGS_STORAGE_KEY } from "../core/storage.js";
/** Gap between title band and score block in the right Fall column (px). */
export const FALL_LOGO_TO_SCORE_GAP_PX = 10;
/**
 * Fall `#scorePanel` minimum height (px). Feeds `getLayout` (`miniFlaskCardTop` / tube band), `_getFallMiniFlaskCardRect`
 * (`scoreBottom`), and `applyRunHudBounds` (`minHeight`). Keep `#app.stage-run #scorePanel` **`min-height`** in `style.css`
 * aligned with this value.
 */
export const FALL_SCORE_PANEL_MIN_HEIGHT_PX = 132;
  /** Relative minimal padding: radius <= (width - 2*padding) / 2, padding = min(w,h) * ratio. 0.05 = 5%. */
export const FLASK_PADDING_RATIO = 0.05;
  /** Legacy symmetric cut-off (kept for backward compatibility when top/bottom cutoffs are not set). */
export const FLASK_CUTOFF_FRACTION = 0.8;
  /** Top visible fraction of flask body height (from center to top). */
export const FLASK_CUTOFF_TOP_FRACTION = 0.8;
  /** Bottom visible fraction of flask body height (from center to bottom). */
export const FLASK_CUTOFF_BOTTOM_FRACTION = 0.9;
  /** Flask collision body aspect (width/height). 1.0 = round, >1 wider, <1 taller. */
export const FLASK_IMAGE_ELLIPSE_ASPECT = 1.08;
  /**
   * Flask collision body size multiplier relative to max fit inside bounds.
   * 1.0 = full fit; lower values shrink the body to match transparent image padding.
   */
export const FLASK_IMAGE_BODY_RADIUS_RATIO = 0.92;
  /** Body radius per tier as fraction of effective diameter. Extra values are ignored when MAX_MERGE_EVOLUTION_TIERS is lower. */
export const FLASK_BODY_RADIUS_RATIOS = [0.01616, 0.02019, 0.02502, 0.03074, 0.03726, 0.04455, 0.05265, 0.06152, 0.07119, 0.08163, 0.09288, 0.10490, 0.11772, 0.13131, 0.14571];
  /** Vertical offset for flask image as fraction of visible flask height. Positive = down. */
export const FLASK_IMAGE_OFFSET_Y = 0.05;

  // ========== FALL/RUN PANEL SCALE + MOUTH GEOMETRY ==========
  /** Effective opening width as fraction of flask image width. ~0.65–0.70 from flask.png. */
export const FLASK_NECK_OPENING_RATIO = 0.67;
  /** Vertical offset for collision Y (rim thickness) as fraction of flask height. */
export const FLASK_NECK_RIM_OFFSET_Y_RATIO = 0.02;
  /** Flask image aspect ratio (height/width) for runway display. Sync with `assets/images/flask.png`. */
export const FLASK_IMAGE_ASPECT_RATIO = 1.36;
  /**
   * Run stage: `desiredTopY = runHeight * (1 - this)`. Higher values move the runway flask up
   * (smaller top Y). Default 0.24 (~4% of height higher than legacy 0.2).
   */
export const FLASK_TOP_FROM_BOTTOM_RATIO = 0.24;

  // ========== MERGE OBJECT SCALE ==========
  /** Default ellipseAspect when not set per tier. 1.0 = circle. */
export const MERGE_BODY_ELLIPSE_ASPECT_DEFAULT = 1.0;
  /** Default ellipseAngle (radians) when not set per tier. */
export const MERGE_BODY_ELLIPSE_ANGLE_DEFAULT = 0;
  /** Multiplier for merge pickups on the runway (caught by flask mouth). 1.0 = default. */
export const RUNWAY_MERGE_PICKUP_SCALE = 3.0;
  /**
   * Multiplier for merge bodies in the flask (physics + render). 1.0 = default.
   * Calibrated for ~2+ in-game day cycles before overflow is a realistic threat (see tests/flask-capacity.test.js).
   */
  export const FLASK_MERGE_SCALE = 3.35;
  /** Multiplier for flask mouth width on the runway. 1.0 = default. */
export const RUNWAY_FLASK_WIDTH_SCALE = 2.2;
  /** Multiplier for flask/player size on the runway (the circular character). 1.0 = default. */
export const RUNWAY_FLASK_SIZE_SCALE = 2.2;

/**
 * @param {number} widthFraction — object width as fraction of run width (from layout).
 * @param {number} runWidthPx
 * @param {object} [runConfig]
 * @returns {number}
 */
export function fallObjectPixelWidth(widthFraction, runWidthPx, runConfig) {
  var rc = runConfig || RUN_CONFIG || {};
  var scale = rc.FALL_OBJECT_SIZE_SCALE != null ? rc.FALL_OBJECT_SIZE_SCALE : 1;
  return widthFraction * runWidthPx * scale;
}

/**
 * Draw-space width/height for a fall runway object.
 * @param {object} obj
 * @param {number} runWidthPx
 * @param {object} [runConfig]
 */
export function getFallObjectDrawSize(obj, runWidthPx, runConfig) {
  var rc = runConfig || RUN_CONFIG || {};
  var type = obj && obj.getType ? obj.getType() : (obj && obj.type) || "";
  var drawWidthFrac = obj && obj.width != null ? obj.width : 0;
  var pixelW = fallObjectPixelWidth(drawWidthFrac, runWidthPx, rc);
  var aspect = obj && obj.getAspectRatio ? obj.getAspectRatio() : 1;
  var safeAspect = aspect > 0 ? aspect : 1;
  var pixelH = pixelW / safeAspect;
  return {
    pixelW: pixelW,
    pixelH: pixelH,
    halfExtent: Math.max(pixelW, pixelH) * 0.5,
  };
}

/**
 * Top draw clip overflow so the largest runway spawn (incl. appear pop) is never cropped.
 * @param {number} runWidthPx
 * @param {object} [runConfig]
 * @param {number} [runHeightPx]
 */
export function computeFallDrawTopOverflowPx(runWidthPx, runConfig, runHeightPx) {
  var rc = runConfig || RUN_CONFIG || {};
  var floor = rc.FALL_DRAW_TOP_OVERFLOW_PX != null ? Math.max(0, Number(rc.FALL_DRAW_TOP_OVERFLOW_PX)) : 120;
  var sizeScale = rc.FALL_OBJECT_SIZE_SCALE != null ? Number(rc.FALL_OBJECT_SIZE_SCALE) : 1;
  if (!isFinite(sizeScale) || sizeScale <= 0) sizeScale = 1;
  var maxFrac = Math.max(
    Number(rc.BONUS_WIDTH_RATIO) || 0.12,
    Number(rc.BOULDER_WIDTH_RATIO) || Number(rc.HAZARD_WIDTH_RATIO) || 0.08,
    Number(rc.GEM_WIDTH_RATIO) || 0.04,
    Number(rc.MERGE_PICKUP_WIDTH_RATIO) || 0.028
  );
  var maxPixel = maxFrac * Math.max(1, runWidthPx) * sizeScale;
  var appearMax = rc.FALL_SPAWN_APPEAR_MAX_SCALE != null ? Number(rc.FALL_SPAWN_APPEAR_MAX_SCALE) : 1.12;
  if (!isFinite(appearMax) || appearMax < 1) appearMax = 1.12;
  var runH = runHeightPx != null ? Number(runHeightPx) : 0;
  if (!isFinite(runH) || runH <= 0) runH = runWidthPx * 1.125;
  var margin = getFallSpawnTopMarginPx(runH, rc);
  var needed = Math.ceil(maxPixel * 0.5 * appearMax + margin);
  return Math.max(floor, needed);
}

/**
 * @param {object} obj
 */
export function getFallSpawnBurstColor(obj) {
  var type = obj && obj.getType ? obj.getType() : (obj && obj.type) || "";
  if (type === "merge_pickup") {
    return (MERGE_PICKUP_COLORS && obj.tier != null && MERGE_PICKUP_COLORS[obj.tier]) || "#94a3b8";
  }
  if (type === "gem") return "#4ade80";
  if (type === "boulder") return "#a08060";
  if (type === "bonus") return "#a78bfa";
  return "#94a3b8";
}

  // ========== FALL STAGE UX ==========
  /**
   * Show fade-shrink animation when an object enters the flask mouth suction zone.
   * false = objects disappear instantly on collection (no animation).
   * true  = objects shrink and fade over FALL_SUCTION_ANIMATION_MS before removal.
   */
export const FALL_SUCTION_ANIMATION_ENABLED = true;

  // ========== DEBUG ==========
  /**
   * TODO(design): Remove when mockup ↔ shipped UI redesign is finished.
   * Shake preview: `?previewShake=1` in the URL, or `VITE_DESIGN_PREVIEW_AUTO_SHAKE_PAUSED=true`.
   * Enters Shake paused for layout tuning — not normal gameplay.
   */
export function isDesignShakePreviewEnabled() {
  if (typeof import.meta !== "undefined" && import.meta.env
    && import.meta.env.VITE_DESIGN_PREVIEW_AUTO_SHAKE_PAUSED === "true") {
    return true;
  }
  if (typeof window !== "undefined" && window.location && window.location.search) {
    return new URLSearchParams(window.location.search).get("previewShake") === "1";
  }
  return false;
}

/** @deprecated Use isDesignShakePreviewEnabled() — kept for existing imports. */
export const DESIGN_PREVIEW_AUTO_SHAKE_PAUSED = isDesignShakePreviewEnabled();

/**
 * Dev-only: boot straight into live Shake (merge) for UI/mechanic testing.
 * Opt-in via `?startShake=1` only — never auto-enabled from env (avoids accidental ship).
 */
export function isDevStartInShakeEnabled() {
  if (typeof window !== "undefined" && window.location && window.location.search) {
    return new URLSearchParams(window.location.search).get("startShake") === "1";
  }
  return false;
}

/**
 * TODO(design): Remove when mockup ↔ shipped UI redesign is finished.
 * Fall preview: default in `.env.development`, or `?previewFall=1` in the URL.
 * Auto-starts Fall (Stage I) paused for layout tuning — not normal shipped bootstrap.
 */
export function isDesignFallPreviewEnabled() {
  if (typeof import.meta !== "undefined" && import.meta.env
    && import.meta.env.VITE_DESIGN_PREVIEW_AUTO_FALL_PAUSED === "true") {
    return true;
  }
  if (typeof window !== "undefined" && window.location && window.location.search) {
    return new URLSearchParams(window.location.search).get("previewFall") === "1";
  }
  return false;
}
  /** Show top debug strip (raw counters like HP/flask count). */
export const SHOW_DEBUG_STRIP = false;
  /** Draw physics body contour over merge object images. true = show, false = hide. */
export const SHOW_PHYSICS_BODY_CONTOUR = false;
  /** Draw flask physics model outline (test flask mode). true = show, false = hide. */
export const SHOW_FLASK_PHYSICS_OUTLINE = false;
  /** TEMP: horizontal line at Matter overflow check Y on the shake flask (tuning aid). */
export const SHOW_OVERFLOW_CHECK_LINE = false;

  // ========== RUN UX ==========
export { RUN_TUTORIAL_STORAGE_KEY as RUN_FIRST_RUN_KEY } from "../core/storage.js";
  /** Fall-only left sidebar width (px) — controls, lives, gems, vertical evolution. */
export const FALL_SIDEBAR_WIDTH_PX = 148;
  /** Fall sidebar top reserve for controls + lives + gems (px); evolution fills below. */
export const FALL_SIDEBAR_HUD_RESERVE_PX = 128;